"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Cryengine = function Cryengine(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.714,14.875c0.296,0,0.58,0.102,0.807,0.288l0.014,0.012l-0.149,0.238 c-0.184-0.168-0.421-0.26-0.671-0.26c-0.549,0-0.995,0.446-0.995,0.995c0,0.549,0.446,0.995,0.995,0.995 c0.497,0,0.91-0.366,0.983-0.842l0.002-0.014h-0.852l0.173-0.277h0.966v0.139c0,0.702-0.571,1.273-1.272,1.273 c-0.702,0-1.272-0.571-1.272-1.273C13.441,15.446,14.012,14.875,14.714,14.875z M1.272,14.875c0.347,0,0.68,0.144,0.918,0.392 l0.012,0.013l-0.157,0.242c-0.19-0.235-0.47-0.37-0.774-0.37c-0.549,0-0.995,0.446-0.995,0.995c0,0.549,0.446,0.995,0.995,0.995 c0.287,0,0.559-0.123,0.748-0.339l0.01-0.012l0.211,0.18C2,17.256,1.646,17.419,1.272,17.419C0.571,17.419,0,16.849,0,16.147 C0,15.446,0.571,14.875,1.272,14.875z M3.712,14.89c0.639,0,0.894,0.3,0.894,0.733c0,0.363-0.184,0.619-0.621,0.706l-0.014,0.003 l0.702,1.075H4.337l-0.663-1.058H3.196v1.058H2.923V14.89H3.712z M9.592,17.163v0.244H7.87v-0.244H9.592z M5.574,14.89l0.691,1.149 c0.024,0.042,0.038,0.087,0.045,0.115c0.01-0.029,0.019-0.067,0.043-0.109l0.006-0.01l0.688-1.145h0.297l-1.564,2.518H5.509 l0.647-1.05L5.274,14.89H5.574z M23.096,17.163v0.244h-1.722v-0.244H23.096z M18.535,14.89l1.512,2.085 c-0.013-0.059-0.02-0.081-0.021-0.127l0-0.009V14.89h0.272v2.518h-0.258l-1.515-2.092c0.01,0.033,0.023,0.078,0.024,0.142l0,0.012 v1.938h-0.272V14.89H18.535z M17.174,14.89v2.518h-0.272V14.89H17.174z M10.779,14.89l1.512,2.085 c-0.013-0.059-0.02-0.081-0.021-0.127l0-0.009V14.89h0.272v2.518h-0.258l-1.515-2.092c0.01,0.033,0.023,0.078,0.024,0.142l0,0.012 v1.938h-0.272V14.89H10.779z M23.096,15.955v0.248h-1.722v-0.248H23.096z M9.592,15.955v0.248H7.87v-0.248H9.592z M3.716,15.134 h-0.52v0.967h0.517c0.384,0,0.615-0.112,0.615-0.478C4.327,15.256,4.096,15.134,3.716,15.134z M23.707,14.567 c0.162,0,0.293,0.13,0.293,0.292c0,0.162-0.131,0.292-0.293,0.292s-0.293-0.13-0.293-0.292 C23.415,14.697,23.546,14.567,23.707,14.567z M23.096,14.89v0.244h-1.722V14.89H23.096z M9.592,14.89v0.244h-1.47l0.151-0.244 H9.592z M23.707,14.616c-0.134,0-0.242,0.108-0.242,0.242c0,0.134,0.108,0.242,0.242,0.242c0.134,0,0.243-0.108,0.243-0.242 C23.95,14.725,23.841,14.616,23.707,14.616z M23.709,14.707c0.075,0,0.108,0.038,0.108,0.091c0,0.04-0.018,0.07-0.059,0.084 l-0.006,0.002l0.08,0.123h-0.058l-0.067-0.104c-0.002-0.002-0.003-0.007-0.004-0.011l0-0.003h-0.058v0.118h-0.048v-0.301H23.709z M23.71,14.753h-0.065v0.091h0.064c0.041,0,0.06-0.011,0.06-0.045C23.769,14.766,23.75,14.753,23.71,14.753z M10.909,6.6 l0.088-0.007c-2.36,0.549-3.761,2.332-3.761,2.564l0,0.001c0,0.001,0.001-0.009,0.002,0.036l0,0.006h0.001 c0.048,0.253,0.745,1.475,3.441,2.201c-3.09-0.245-4.494-1.748-4.563-2.188L6.116,9.199H6.115c0-0.046-0.001-0.037-0.001-0.034l0,0 l0.001-0.013C6.152,8.7,8.043,6.84,10.909,6.6l0.088-0.007L10.909,6.6z M11.89,6.581c3.209,0.167,5.076,2.075,5.093,2.609l0-0.001 c0-0.002-0.001,0-0.001,0.033l0,0.006H16.98c-0.025,0.268-1.045,1.358-2.571,1.86c-1.865,0.613-4.866,0.39-4.866-1.948 c0-1.097,0.894-1.99,1.992-1.99c1.108,0,1.997,0.897,1.997,1.995c0,0.535-0.231,1.053-0.581,1.419 c0.327-0.006,1.517-0.093,2.638-1.017c0.124-0.121,0.203-0.222,0.236-0.284c0.009-0.016,0.022-0.045,0.02-0.072 C15.846,8.951,14.557,7.107,11.89,6.581z M11.533,8.008c-0.625,0-1.131,0.506-1.131,1.131c0,0.625,0.506,1.131,1.131,1.131 c0.624,0,1.131-0.506,1.131-1.131C12.664,8.515,12.158,8.008,11.533,8.008z M16.982,9.19C16.982,9.19,16.982,9.19,16.982,9.19 L16.982,9.19z"
  }));
};

Cryengine.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Cryengine.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Cryengine;
exports.default = _default;